import { isForeignAuthorFeatureEnabled } from 'constant';

export const regexPass = /^(?=.*[a-zA-Z])(?=.*\d)|^(?=.*[a-zA-Z])(?=.*[#$^+=!*()@%&.])|^(?=.*[a-z])(?=.*[A-Z])|(?=.*\d)(?=.*[#$^+=!*()@%&.])/;

export const isamMail = /.@isam.org.tr$/gm;

export const yokAkademikBaseURL = 'https://akademik.yok.gov.tr/AkademikArama/AkademisyenGorevOgrenimBilgileri?islem=direct&authorId=';
export const yokAkademikRegex = /^https?:\/\/akademik\.yok\.gov\.tr.*authorId=.+/gi;

export const METADATA = {
  dahStatus: 'Tematik Ansiklopediler Eşgüdüm Kurulu:',
  dahDescription: 'Tematik Ansiklopediler Eşgüdüm Kurulu Karar Gerekçe Metni:',
  dahStatusChangeCommittee: 'Tematik Ansiklopediler Eşgüdüm Kurulumaddenin sorumlu heyetini değiştirdi.',
  committeeStatus: 'Sorumlu İlim Heyeti:',
  statusDescription: 'Sorumlu Heyet Gerekçe Metni:',
  aykStatus: 'Ansiklopedi Yayın Kurulu:',
  aykDescription: 'Ansiklopedi Yayın Kurulu Gerekçe Metni:',
  title: 'Teklif Edilen Madde Başlığı:',
  ownerCommittee: 'Teklifi Yapan İlim Heyeti:',
  otherCommittees: 'Sorumlu İlim Heyeti:',
  oldTitle: "İslam Ansiklopedisi'nde geçen başlık:",
  oldArticleWorkType: 'İkinci edisyon kapsamında yapılacak çalışma:',
  oldArticles: 'Zikredilen madde metinleri:',
  articleGroup: 'Teklif edilen maddenin grubu:',
  articleType: 'Teklif edilen maddenin türü:',
  committeeContribution: 'Katkıda bulunacak heyet:',
  committeeContributionType: 'Katkıda bulunacak heyetten beklenen çalışma:',
  committeeContributionOther: 'Katkıda bulunacak heyetten beklenen çalışma:',
  statusChangeCommittee: 'İlim Heyeti değiştirildi:',
  offerReason: 'Teklifin Gerekçesi değişitirildi.',
  articleTypeOther: 'Madde türünde değişiklik yapıldı.',
  dahRevertReasonAnswers: 'İade Sebebi:',
  offerTitle: '“Madde Adı” ile ilgili yönergeye uygunluk:',
  offerGroup: '“Madde Grubu” değişikliği:',
  offerType: '“Madde Türü” değişikliği:',
  offerSecondEditionSuitability: 'Tematik Ansiklopediler kapsamına uygunluk:',
  offerCommitteePriority: 'İlim heyeti önceliğine uygunluk:',
  offerCommitteeDetectAndChange: '“Katkıda Bulunacak İlim Heyeti” tespiti veya değişikliği:',
  offerCommitteeContributionChange: '“Katkıda Bulunacak İlim Heyeti”nin katkı türü değişikliği:',
  offerReasonSufficiency: 'Madde Tespit Formu’ndaki “Gerekçe” bölümünün yeterliliği:',
  committee: 'Katkıda Bulunacak Heyet',
  type: 'Katkıda bulunacak heyetten beklenen çalışma:',
  other: 'Katkıda bulunacak heyetten beklenen çalışma (Diğer) :',
  articleLength: '"Madde Hacmi" değişikliği',
  articleLengthReason: '"Madde Hacmi Gerekçesi" değişikliği',
  articleSupervisor: '"Madde Sorumlusu" değişikliği',
  contentFormFilled: 'Madde İçerik Formu dolduruldu.',
  author: 'Madde yazarlarında değişiklik yapıldı.',
  media: 'Ek dosyalarda değişiklik yapıldı.',
  offerContentWrongAuthorInfo: 'İçerik formunda belirtilen yazar bilgileri hatalıdır.',
  offerContentAuthorInfoNotEnough: '"Madde Yazarı" için sunulan gerekçe yeterli değildir.',
  offerContentArticleLengthReasonNotEnough: '"Madde Hacmi" için sunulan gerekçe yeterli değildir.',
  offerContentAdditionalInfoNotEnough: 'Gönderilen ek bilgi şekil, üslup ve içerik açısından uygun değildir.',
  offerContentMediaNotEnough: 'Gönderilen ek dosyalar madde tür ve içeriğine uygun değildir.',
};

export const ENTITY = {
  entity_edit: 'Madde formunda değişiklik yapıldı.',
  // entity_decision: 'Madde Hakkında Karar Verildi.',
  entity_decision: '',
};
export const afterCopyrightStatus = {
  27: 'TS - Madde Atama',
  28: 'AB - Madde Başlığı Redaksiyonu',
  30: 'AB - Ayet Hadis Kontrolü',
  51: 'AB - Yazma eser Kontrolü',
  34: 'AB - Üslup/metin Redaksiyonu',
  31: 'AB - Madde Özü Yazımı ve redaksiyonu',
  32: 'AB - Kimlik Kartı Redaksiyonu',
  33: 'AB - Üst Veri ve Kavram Ağacı Redaksiyonu',
  35: 'AB - Metin içi veri ve atıf-ilişkili madde kontrolü',
  36: 'AB - Medya Teklifi Kontrolü',
  37: 'TS - Ansiklopedi Birimi Kontrol',
  38: 'TS - İH Madde Kontrol',
  53: 'TS - Madde sorumlusu kontrol',
  39: 'TS - Yayın Müdürlüğü Madde Atama',
  40: 'YM - Atıf - Kaynaklar Redaksiyonu',
  41: 'YM - Çeviri - Yazı Redaksiyonu',
  42: 'YM - İmla Redaksiyonu',
  52: 'YM - Editöryal Son Okuma',
  43: 'TS - Yayın Müdürlüğü Kontrol',
  44: 'TS - Ansiklopedi Yayın Kurulu Kontrol',
  47: 'IH - Yeniden Yazım',
  48: 'IH - Telif - Tamamlandı',
  49: 'IH - Madde sorumlusu kontrol',
  45: 'İptal Edildi',
  46: 'Terk Edildi',
};

export const ORDER_STATUS = {
  20: 'SB - Gündemde',
  21: 'Yazar - Onay',
  22: 'Yazar - Gündemde',
  23: 'SB - Madde Kontrol',
  24: 'IH - Madde Kontrol',
  25: 'IH - Madde Kontrol Görüş İstedi',
  26: 'IH - Madde Kontrol Yeniden Telif',
  ...(isForeignAuthorFeatureEnabled && { 54: 'IH - Tercüme' }),
};

export const OFFER_STATUS = {
  0: 'İH - Gündemde',
  1: 'İH - Beklemede',
  5: 'TAEK - Gündemde', // eski sistemdeki ismi DAH - Gündemde
  6: 'TAEK - İnceleme', // eski sistemdeki ismi DAH - Beklemede
  11: 'AYK - Gündemde',
  12: 'AYK - İnceleme',
  17: 'Onaylandı',
  18: 'Reddedildi',
  19: 'İH - Taslak',
  ...ORDER_STATUS,
  ...afterCopyrightStatus,
};

/**
 * @description OFFER_STATUS'ın keys'leri offerStatus objesinideki keyler intager like oldugu icin Object,keys kullanildiginda kucukten buyuge siralanir
 * bunun icin OFFER_STATUS_KEYS arrayini olusturduk custom bir siralama icin ve bu arrayi kullanarak OFFER_STATUS objesini kullanabiliriz.
 * BE ile gorusuldu ilerleyen surecde bu status lerin BE den gelmesi saglanacak. kisa vadeli bu cozum uygulandi
 */
export const OFFER_STATUS_KEYS = [
  '0',
  '1',
  '5',
  '6',
  '11',
  '12',
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
  '49',
  ...(isForeignAuthorFeatureEnabled ? ['54'] : []),
  '25',
  '26',
  '27',
  '28',
  '30',
  '51',
  '34',
  '31',
  '32',
  '33',
  '35',
  '36',
  '37',
  '38',
  '53',
  '39',
  '40',
  '41',
  '42',
  '52',
  '43',
  '44',
  '47',
  '48',
  '45',
  '46',
  '17',
  '18',
];

export const ilimHeyetiKarariSebebi = {
  2: "Teklif ettiğiniz başlığın Tematik Ansiklopediler'de madde olarak yer almasının gerekçesini kısaca izah ediniz:",
  0: 'İade Sebebi:',
  1: 'Bekletme Sebebi:',
  3: 'İlim Heyeti Değiştirme gerekçesi:',
};

export const oldArticleWorkTypes = {
  0: 'Yeniden Yazım',
  1: 'İkmal',
  2: 'Kapsamlı Gözden Geçirme',
  3: 'Tashih',
  6: 'Görsel Güncellemesi',
  7: 'Yeni Bölüm ilavesi',
};

export const heyetKarari = {
  3: 'İADE',
  1: 'BEKLET',
  2: 'KABUL',
  4: 'İLİM HEYETİ DEĞİŞTİR',
};

export const heyetKarariMetin = {
  0: 'Gündemde',
  3: 'İade Edildi',
  1: 'Bekletiliyor',
  2: 'Kabul Edildi',
  4: 'İlim Heyeti Değiştirildi',
  5: 'Reddedildi',
  6: 'Havale',
  7: 'Taslak',
  8: 'Geri Çekti',
  9: 'Geri Çekildi',
  null: 'Heyet Kararı Verilmedi',
};

export const contributorWorks = {
  0: 'Bilgi, terminoloji ve kaynak kontrolü',
  1: 'Ek bilgi girişi',
  2: 'Ayrı bölüm yazımı',
};

export const COMI = ['committees', 'heads', 'secretaries', 'specialties'];

export const MISSION = {
  0: 'Heyet Başkanı',
  1: 'Heyet Sekreteri',
  3: 'Heyet Uzmanı',
  2: 'Heyet Üyesi',
};

export const formType = {
  dah: 'TAEK Kararı', // eski sistemdeki ismi Disiplinlerarası Heyet Kararı
  committee: 'İlim Heyeti Kararı',
  ayk: 'AYK Kararı',
  MTF: 'Madde Teklif Formu Kararı',
};

export const ROLE = {
  0: { color: 'green', title: 'Başkan' },
  1: { color: 'red', title: 'Sekreter' },
  3: { color: 'blue', title: 'Uzman' },
  2: { color: 'volcano', title: 'Üye' },
};

export const ROLES_DEF = {
  ROLE_ADMIN: 'Admin',
  ROLE_DAH: 'TAEK Üyesi',
  ROLE_COMMITTEE: 'İlim Heyeti Üyesi',
  ROLE_AYK: 'AYK Üyesi',
  ROLE_USER: 'Normal Kullanıcı',
  ROLE_EU_MANAGER: 'Ansiklopedi Birimi Yöneticisi',
  ROLE_PUB_MANAGER: 'Yayın Birimi Yöneticisi',
  ROLE_ERESOURCE: 'Elektronik Kaynak Yöneticisi',
  ROLE_RESOURCE_USER: 'Elektronik Kaynak Kullanıcısı',
  ROLE_RESOURCE_AND_GUIDE_USER: 'Elektronik Kaynak ve Kılavuz Kullanıcısı',
  ROLE_SUPER_ADMIN: 'Süper Admin',
  ROLE_AUTHOR: 'Yazar',
  ROLE_ORDER_UNIT: 'Sipariş Birimi',
  ROLE_EU_EMPLOYEE: 'Ansiklopedi Birimi Çalışanı',
  ROLE_PUB_EMPLOYEE: 'Yayın Müdürlüğü Çalışanı',
  ROLE_POST_ORDER_TEXT_DATA_CONTROL: 'AB - Metin İçi Veri Kontrolü',
  ROLE_POST_ORDER_TITLE_REDACTION: 'AB - Madde Başlığı Redaksiyonu',
  ROLE_POST_ORDER_VERSE_CONTROL: 'AB - Ayet Hadis Kontrolü',
  ROLE_POST_ORDER_ESSENCE_REDACTION: 'AB - Madde Özü Redaksiyonu',
  ROLE_POST_ORDER_IDENTITY_REDACTION: 'AB - Kimlik Kartı Redaksiyonu',
  ROLE_POST_ORDER_UVKA_REDACTION: 'AB - Üst Veri ve Kavram Ağacı Redaksiyonu',
  ROLE_POST_ORDER_WORD_REDACTION: 'AB - Üslup Redaksiyonu',
  ROLE_POST_ORDER_CITATION_RELATION_CONTROL: 'AB - Atıf ve İlişkili Madde Kontrolü',
  ROLE_POST_ORDER_MEDIA_OFFER_CONTROL: 'AB - Medya Teklifi Kontrolü',
  ROLE_POST_ORDER_CITATION_SOURCE_REDACTION: 'YM - Atıf - Kaynaklar Redaksiyonu',
  ROLE_POST_ORDER_TRANSLATION_TEXT_REDACTION: 'YM - Çeviri - Yazı Redaksiyonu',
  ROLE_POST_ORDER_ORTHOGRAPHY_REDACTION: 'YM - İmla Redaksiyonu',
  ROLE_POST_ORDER_PROOFREADING_CONTROL: 'YM - Editöryal Son Okuma',
};
export const NOTE_TYPES = [
  [1, 'Telefon Görüşmesi'],
  [2, 'Email'],
];

export const STEP_DEF = {
  1: 'detection',
  3: 'order',
  4: 'afterCopyright',
  5: 'publish',
};

export const educationTypes = ['Lisans', 'Yüksek Lisans', 'Doktora'];

export const articleLength = ['50-250', '500-1500', '1500-3500', '3500-7000', '7000 +'];

export const opinionTypes = {
  approved: 'Onaylandı',
  rejected: 'Reddedildi',
  pending: 'Cevap bekleniyor',
  notAnswered: 'Cevap verilmedi',
};

export const pullbackStatus = ['pending', 'approved', 'rejected'];

/**
 * Heyet goruslerini temsil eder bu idler BE de de ayni sekildedir.
 * statik olarak vermemiz gereken alanlarda typo hatalari olamamasi adina bir sabit icerisinda saklandi
 */
export const committeeDecisions = {
  opinion: 1,
  approved: 2,
  rejected: 5,
  revert: 3,
  rewrite: 4,
  sendSupervisor: 6,
  pullback: 8,
  sendTranslation: 9,
};

/**
 * TODO: IdCardRequired için kullanılan maddelerin kaynağını backend olacak şekilde çalışma yapılması gerekiyor.
 * Madde türleri kimlik kartının zorunlu olduğu alanlar
 * 1 -> Biyografi
 * 2 -> Kavram
 * 5 -> Olay
 * 6 -> Kurum-Ağ
 * 7 -> Akım-Ekol
 * 8 -> Mekan-Yer
 * 9 -> Nesne
 * 19 -> Metin-Literatür
 * 20 -> Mimari-Sanat Eseri
 * 21 -> Disiplin-İlim
 * 22 -> Din
 */
export const idCardRequired = [1, 2, 5, 6, 7, 8, 9, 19, 20, 21, 22];

export const datePickerFormat = 'DD MMMM YYYY';

export const emailRegex = /^[a-zA-Z0-9][a-zA-Z0-9._%+-]*@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;

export const currencyFormatter = (price, format) => {
  return new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency: format,
    minimumFractionDigits: 2,
  }).format(price);
};
export const phoneformatter = (value) => {
  return `(${value.slice(0, 3)}) ${value.slice(3, 6)} ${value.slice(6, 8)} ${value.slice(8, 10)}`;
};
